import React from 'react';
import { Button } from '../ui/Button';
export function CtaSection() {
  return <section className="py-16 bg-[#0099A1] relative overflow-hidden" data-id="element-194">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-195">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-196">
          <defs data-id="element-197">
            <pattern id="wave" patternUnits="userSpaceOnUse" width="100" height="20" patternTransform="rotate(45)" data-id="element-198">
              <path d="M0 10 Q 12.5 0, 25 10 T 50 10 T 75 10 T 100 10" fill="none" stroke="white" strokeWidth="2" data-id="element-199" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#wave)" data-id="element-200" />
        </svg>
      </div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-201">
        <div className="max-w-3xl mx-auto text-center" data-id="element-202">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-203">
            Ready to Swap Your Boardroom for the Beach?
          </h2>
          <p className="text-xl text-white/80 mb-8" data-id="element-204">
            Let's create an unforgettable experience that drives real business
            results.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-205">
            <Button variant="primary" size="lg" href="https://form.typeform.com/to/QUkK2HU7" data-id="element-206">
              Book a Discovery Call
            </Button>
            <Button variant="outline" size="lg" className="border-white text-white hover:bg-white/10" href="https://api.whatsapp.com/send?phone=19052152109" data-id="element-207">
              Start WhatsApp Chat
            </Button>
          </div>
        </div>
      </div>
    </section>;
}